import { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import ProfileSidebar from "components/organisms/ProfileSidebar";
import { formatNotificationSideBarProfile } from "helpers/notificationsNavigation";
import { useNotificationUserBonuses } from "hooks/useNotificationUserBonuses";
import { referralApi } from "redux/referral/api";
import * as referralSelectors from "redux/referral/selectors";
import { useSplitServiceData } from "../../queries/useSplitServiceData";

const ProfileSidebarContainer = () => {
  const { enabled } = useSelector(referralSelectors.all);
  const { data: isReferralEnabledFromApi } = referralApi.useEnabledQuery();
  const { loyaltyAccess } = useSplitServiceData();

  const isReferralEnabled = isReferralEnabledFromApi ?? enabled;

  const { isActive: bonusesNotificationActive } = useNotificationUserBonuses();
  const notifications = useMemo(
    () =>
      formatNotificationSideBarProfile({
        myBonuses: bonusesNotificationActive,
      }),
    [bonusesNotificationActive],
  );

  return (
    <ProfileSidebar
      navNotifications={notifications}
      enabledReferral={isReferralEnabled}
      showLoyaltyContent={loyaltyAccess}
    />
  );
};

export default memo(ProfileSidebarContainer);
